import GalleryModal from '@/js/plugins/GalleryModal';
import { withUrlPrefix } from '@/js/helpers';

const parseImages = (raw) => {
    if (!raw) return [];
    try {
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed
            .map((item) => {
                if (typeof item === 'string') {
                    return { src: item, alt: '' };
                }
                return {
                    src: item?.src || item?.imagePath || '',
                    alt: item?.alt || item?.comment || '',
                };
            })
            .filter((item) => item.src);
    } catch (e) {
        return [];
    }
};

/**
 * TOPおすすめ（.c-property / .p-home-pickup__item）／一覧カード（.c-cards-estate）共通
 * 間取り・写真一覧 → 詳細ページと同じ GalleryModal
 */
const main = () => {
    let activeModal = null;

    document.addEventListener('click', (event) => {
        const button = event.target.closest('.js-property-gallery-open');
        if (button == null) return;

        event.preventDefault();
        event.stopPropagation();

        const card = button.closest('.c-property, .c-cards-estate, .p-home-pickup__item');
        if (card == null) return;

        const type = button.dataset.galleryType || 'list';
        const attr = type === 'madori' ? 'madoriImages' : 'galleryImages';
        // data-* はカード本体、または内側の .c-property に付与されている場合がある
        const dataHost = card.matches('.c-property, .c-cards-estate')
            ? card
            : (card.querySelector('.c-property, .c-cards-estate') || card);
        const imgList = parseImages(dataHost.dataset[attr]);
        if (imgList.length === 0) {
            console.warn('[property-gallery] images empty', { type, attr, raw: dataHost.dataset[attr] });
            return;
        }

        const id = dataHost.dataset.id || '';
        // data-* が無いときのフォールバックはここでURLを自前で組むため、route() を通らない。
        // 本番は /bunjo 配下なので接頭辞を足さないとコーポレートサイト側へ飛んで404になる
        const contactUrl = dataHost.dataset.contactUrl
            || (id ? withUrlPrefix(`/inquiry/${id}`) : '');
        const visitUrl = dataHost.dataset.visitUrl
            || (id ? withUrlPrefix(`/viewing-reservation/${id}`) : '');

        activeModal?.destroy?.();
        activeModal = new GalleryModal({
            overlayClose: true,
            imgList,
            contactUrl,
            visitUrl,
            mode: type === 'list' ? 'list' : 'single',
        });
        window.setTimeout(() => {
            activeModal.show(0);
        }, 50);
    });
};

export default main;
